import {
  ENQUEUE_PUBLISH_JOB,
  REMOVE_PUBLISH_JOB,
  UPDATE_PUBLISH_JOB_PROGRESS,
  MARK_BANNER_LIST_STALE,
  CLEAR_BANNER_LIST_STALE,
  MARK_TEMPLATE_LIST_STALE,
  CLEAR_TEMPLATE_LIST_STALE,
  MARK_PARTNERS_LIST_STALE,
  CLEAR_PARTNERS_LIST_STALE,
  MARK_BRANDS_LIST_STALE,
  CLEAR_BRANDS_LIST_STALE,
  MARK_DEPARTMENTS_LIST_STALE,
  CLEAR_DEPARTMENTS_LIST_STALE,
  MARK_PAGES_LIST_STALE,
  CLEAR_PAGES_LIST_STALE,
  MARK_CAREERS_LIST_STALE,
  CLEAR_CAREERS_LIST_STALE,
  MARK_CAREER_APPLICATIONS_LIST_STALE,
  CLEAR_CAREER_APPLICATIONS_LIST_STALE,
  MARK_OUR_TEAM_LIST_STALE,
  CLEAR_OUR_TEAM_LIST_STALE,
  MARK_PROJECTS_LIST_STALE,
  CLEAR_PROJECTS_LIST_STALE,
  MARK_CATEGORIES_LIST_STALE,
  CLEAR_CATEGORIES_LIST_STALE,
  MARK_WIDGETS_LIST_STALE,
  CLEAR_WIDGETS_LIST_STALE,
  MARK_SEO_LIST_STALE,
  CLEAR_SEO_LIST_STALE,
  MARK_INFORMATION_POLICY_LIST_STALE,
  CLEAR_INFORMATION_POLICY_LIST_STALE,
  MARK_ADMIN_SETTINGS_STALE,
  CLEAR_ADMIN_SETTINGS_STALE,
  MARK_CONFIG_SETTINGS_STALE,
  CLEAR_CONFIG_SETTINGS_STALE,
} from '../constants/PendingPublish';
import { PUBLISH_CONTENT_TYPES } from 'helpers/publishContentTypes';

export const enqueuePublishJob = (payload) => ({
  type: ENQUEUE_PUBLISH_JOB,
  payload,
});

export const updatePublishJobProgress = (payload) => ({
  type: UPDATE_PUBLISH_JOB_PROGRESS,
  payload,
});

export const removePublishJob = (id) => ({
  type: REMOVE_PUBLISH_JOB,
  payload: id,
});

export const markBannerListStale = () => ({
  type: MARK_BANNER_LIST_STALE,
});

export const clearBannerListStale = () => ({
  type: CLEAR_BANNER_LIST_STALE,
});

export const markTemplateListStale = () => ({
  type: MARK_TEMPLATE_LIST_STALE,
});

export const clearTemplateListStale = () => ({
  type: CLEAR_TEMPLATE_LIST_STALE,
});

export const markPartnersListStale = () => ({
  type: MARK_PARTNERS_LIST_STALE,
});

export const clearPartnersListStale = () => ({
  type: CLEAR_PARTNERS_LIST_STALE,
});

export const markBrandsListStale = () => ({
  type: MARK_BRANDS_LIST_STALE,
});

export const clearBrandsListStale = () => ({
  type: CLEAR_BRANDS_LIST_STALE,
});

export const markDepartmentsListStale = () => ({
  type: MARK_DEPARTMENTS_LIST_STALE,
});

export const clearDepartmentsListStale = () => ({
  type: CLEAR_DEPARTMENTS_LIST_STALE,
});

export const markPagesListStale = () => ({
  type: MARK_PAGES_LIST_STALE,
});

export const clearPagesListStale = () => ({
  type: CLEAR_PAGES_LIST_STALE,
});

export const markCareersListStale = () => ({
  type: MARK_CAREERS_LIST_STALE,
});

export const clearCareersListStale = () => ({
  type: CLEAR_CAREERS_LIST_STALE,
});

export const markCareerApplicationsListStale = () => ({
  type: MARK_CAREER_APPLICATIONS_LIST_STALE,
});

export const clearCareerApplicationsListStale = () => ({
  type: CLEAR_CAREER_APPLICATIONS_LIST_STALE,
});

export const markOurTeamListStale = () => ({
  type: MARK_OUR_TEAM_LIST_STALE,
});

export const clearOurTeamListStale = () => ({
  type: CLEAR_OUR_TEAM_LIST_STALE,
});

export const markProjectsListStale = () => ({
  type: MARK_PROJECTS_LIST_STALE,
});

export const clearProjectsListStale = () => ({
  type: CLEAR_PROJECTS_LIST_STALE,
});

export const markCategoriesListStale = () => ({
  type: MARK_CATEGORIES_LIST_STALE,
});

export const clearCategoriesListStale = () => ({
  type: CLEAR_CATEGORIES_LIST_STALE,
});

export const markWidgetsListStale = () => ({
  type: MARK_WIDGETS_LIST_STALE,
});

export const clearWidgetsListStale = () => ({
  type: CLEAR_WIDGETS_LIST_STALE,
});

export const markSeoListStale = () => ({
  type: MARK_SEO_LIST_STALE,
});

export const clearSeoListStale = () => ({
  type: CLEAR_SEO_LIST_STALE,
});

export const markInformationPolicyListStale = () => ({
  type: MARK_INFORMATION_POLICY_LIST_STALE,
});

export const clearInformationPolicyListStale = () => ({
  type: CLEAR_INFORMATION_POLICY_LIST_STALE,
});

export const markAdminSettingsStale = () => ({
  type: MARK_ADMIN_SETTINGS_STALE,
});

export const clearAdminSettingsStale = () => ({
  type: CLEAR_ADMIN_SETTINGS_STALE,
});

export const markConfigSettingsStale = () => ({
  type: MARK_CONFIG_SETTINGS_STALE,
});

export const clearConfigSettingsStale = () => ({
  type: CLEAR_CONFIG_SETTINGS_STALE,
});

export const markListStaleForContentType = (contentType) => {
  switch (contentType) {
    case PUBLISH_CONTENT_TYPES.BANNER:
      return markBannerListStale();
    case PUBLISH_CONTENT_TYPES.TEMPLATE:
      return markTemplateListStale();
    case PUBLISH_CONTENT_TYPES.PARTNERS:
      return markPartnersListStale();
    case PUBLISH_CONTENT_TYPES.BRANDS:
      return markBrandsListStale();
    case PUBLISH_CONTENT_TYPES.DEPARTMENTS:
      return markDepartmentsListStale();
    case PUBLISH_CONTENT_TYPES.PAGES:
      return markPagesListStale();
    case PUBLISH_CONTENT_TYPES.CAREERS:
      return markCareersListStale();
    case PUBLISH_CONTENT_TYPES.CAREER_APPLICATIONS:
      return markCareerApplicationsListStale();
    case PUBLISH_CONTENT_TYPES.OUR_TEAM:
      return markOurTeamListStale();
    case PUBLISH_CONTENT_TYPES.PROJECTS:
      return markProjectsListStale();
    case PUBLISH_CONTENT_TYPES.CATEGORIES:
      return markCategoriesListStale();
    case PUBLISH_CONTENT_TYPES.WIDGETS:
      return markWidgetsListStale();
    case PUBLISH_CONTENT_TYPES.SEO:
      return markSeoListStale();
    case PUBLISH_CONTENT_TYPES.INFORMATION_POLICY:
      return markInformationPolicyListStale();
    case PUBLISH_CONTENT_TYPES.ADMIN_SETTINGS:
      return markAdminSettingsStale();
    case PUBLISH_CONTENT_TYPES.CONFIG_SETTINGS:
      return markConfigSettingsStale();
    default:
      return { type: 'NOOP' };
  }
};
